import { Injectable } from "@angular/core";
import { AdditionalField } from "@fiduciaria/Shared/Types/escrow.interface";
import { RequiredInfo } from "@fiduciaria/Shared/Types/required-info.interface";
import { BehaviorSubject, Observable } from "rxjs";

import { FormValueService } from "@shared/Services/form-value.service";

import { TrustService } from "../../Shared/Services/trust.service";
import { CreationRequest, CreationResponse } from "../Types/Interfaces/new-request-creation.interface";

@Injectable()
export class RequestCreationFormService extends FormValueService<CreationRequest, CreationResponse> {
  constructor(private trustService: TrustService) {
    super();
  }

  protected _requiredInfo = new BehaviorSubject<RequiredInfo>({
    showAmount: false,
    showCurrency: false,
    showStage: false,
    showCustomer: false,
    showInvoiceQuantity: false,
  });

  protected _additionalRequiredFields = new BehaviorSubject<AdditionalField[]>([]);

  public get additionalRequiredFields$(): Observable<AdditionalField[]> {
    return this._additionalRequiredFields.asObservable();
  }

  public get requiredInfo(): Observable<RequiredInfo> {
    return this._requiredInfo.asObservable();
  }

  public addValue(addedValue: Partial<CreationRequest>): void {
    super.addValue(addedValue);

    const currentSubType = addedValue?.subtype?.sCodigo;
    const prevSubType = this._value.value?.subtype?.sCodigo;
    if (currentSubType === prevSubType) {
      this.fetchRequiredInfo(currentSubType);
      this.fetchAdditionalRequiredFields(addedValue.subtype.key);
    }
  }

  public fetchRequiredInfo(subTypeCode: string): void {
    this.trustService.getRequiredInfo(subTypeCode).subscribe((requiredInfo) => {
      this._requiredInfo.next(requiredInfo);
    });
  }

  public fetchAdditionalRequiredFields(subTypeCode: string): void {
    this.trustService.getAdditionalRequiredFields(subTypeCode).subscribe((additionalRequiredFields) => {
      this._additionalRequiredFields.next(additionalRequiredFields);
    });
  }
}
